import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

interface DialogData {

}

@Component({
  selector: 'app-new-industry',
  templateUrl: './new-industry.component.html',
  styleUrls: ['./new-industry.component.scss']
})
export class NewIndustryComponent implements OnInit {
  newIndustryForm: FormGroup;
  isNewIndustryAdded = false;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogref: MatDialogRef<NewIndustryComponent>,
    private toastr: ToastrService
  ) { }

  ngOnInit() {

    this.newIndustryForm = this.fb.group({
      'new_industry_name': ["", [Validators.required, Validators.minLength(2)]],
    });

  }

  cancel() {
    this.dialogref.close();
  }

  submit() {

    if (this.newIndustryForm.valid) {
      this.dialogref.close({ data: this.newIndustryForm.value })
    }
    else {
      this.toastr.error('Please enter a valid new industry name', 'Error');
    }


  }

}
